module.exports = __webpack_public_path__ + "media/images/global/icons/dish-345f610948c55aa4ceca7f5384070347.svg";